import { MetadataFieldModeType } from '@interacta-shared/util-caronte';
import { toCustomFieldDefinitions } from '@interacta/data-access-community';
import type { ILinkedBy } from '@interacta/util-community';
import { CommunityTreeDeserialize } from '@modules/communities/models/communities.model';

export const toLinkedBy = (record: NonNullable<any>): ILinkedBy => ({
    community: CommunityTreeDeserialize.communityInfoDetails(record?.community),
    postLinkFieldDefinitions: toCustomFieldDefinitions(
        record.postLinkFieldDefinitions,
        MetadataFieldModeType.POST,
    ),
    screenLinkFieldDefinitions: toCustomFieldDefinitions(
        record.screenLinkFieldDefinitions,
        MetadataFieldModeType.SCREEN,
    ),
});
